import { render, staticRenderFns } from "./AskQuestion.vue?vue&type=template&id=2d96c885&scoped=true"
import script from "./AskQuestion.vue?vue&type=script&lang=ts"
export * from "./AskQuestion.vue?vue&type=script&lang=ts"
import style0 from "./AskQuestion.vue?vue&type=style&index=0&id=2d96c885&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d96c885",
  null
  
)

export default component.exports